<template>
	<div>
		
		<!-- ===== 面包屑导航 ===== -->
		<div class="breadcrumb f-bct animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">{{$t('omsg.t1')}}：</span>
				<span class="crumb-home">我的包裹</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">包裹详情</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>
		
		<!-- 状态 -->
		<div class="packStatus animate__animated  ">
			<el-steps :active="status" process-status="finish" align-center>
				
			  <el-step>
				<template #title>
					<span class="status-t1">入库</span>
				</template>
				<template #description>
					<span class="status-t2" v-if="status>=0">{{pkg.putTime||'未记录'}}</span>
					<span class="status-t2" v-else>未记录</span>
				</template>
				<template #icon>
					<span class="status-t3" :class="status>=0?'status-t3-a':''"></span>
				</template>
			  </el-step>
			  
			  <el-step>
				  <template #title>
				  	<span class="status-t1">打包</span>
				  </template>
				  <template #description>
				  	<span class="status-t2" v-if="status>=1">{{pkg.packTim||'未记录'}}</span>
					<span class="status-t2" v-else>未记录</span>
				  </template>
				  <template #icon>
				  	<span class="status-t3" :class="status>=1?'status-t3-a':''"></span>
				  </template>
			  </el-step>
			  
			  <el-step title="发出">
				  <template #title>
				  	<span class="status-t1">发出</span>
				  </template>
				  <template #description>
				  	<span class="status-t2" v-if="status>=2">{{pkg.sendTime||'未记录'}}</span>
				  	<span class="status-t2" v-else>未记录</span>
				  </template>
				  <template #icon>
				  	<span class="status-t3" :class="status>=2?'status-t3-a':''"></span>
				  </template>
			  </el-step>
			  
			  <el-step>
				  <template #title>
				  	<span class="status-t1">到达</span>
				  </template>
				  <template #description>
				  	<span class="status-t2" v-if="status>=3">{{pkg.arrivedTime||'未记录'}}</span>
					<span class="status-t2" v-else>未记录</span>
				  </template>
				  <template #icon>
				  	<span class="status-t3" :class="status>=3?'status-t3-a':''"></span>
				  </template>
			  </el-step>
			</el-steps>
			
		</div>
		
		<!-- 表格 -->
		<div class="msgBox f-bct animate__animated  ">
			<div class="table newTable">
				<div class="title f-ct">
					<div class="t1">产品信息</div>
					<div class="t2">数量</div>
					<div class="t3">长(cm)</div>
					<div class="t4">宽(cm)</div>
					<div class="t5">高(cm)</div>
					<div class="t6">体积(㎡)</div>
					<div class="t7">重量(kg)</div>
					<div class="t8">货物类型</div>
				</div>
				<div class="goodsItem" v-for="(item,index) in packageList">
					<div class="topBox f-ct">
						<div class="sn f-ct">
							<p>单号：{{pkg.expressNumber}}</p>
							<el-image @click="copy_txt(pkg.expressNumber)" :src="require('@/static/add2/51.png')"></el-image>
						</div>
						<div class="time">唛头：{{pkg.memberMarks||'?'}}</div>
					</div>
					<div class="gmsg f-ct">
						<div class="b1">
							<div class="b1itm flex">
								<el-image v-if="!item.gallery.length" :src="imgDef1" fit="cover"></el-image>
								<el-image v-else :src="item.gallery[0]" fit="cover"></el-image>
								<div class="txtBox">
									<div class="t2 line3">{{item.name||'?'}}</div>
								</div>
							</div>
						</div>
						<div class="b2">{{item.pieceNum||'?'}}</div>
						<div class="b3">{{pkg.length||'?'}}cm</div>
						<div class="b4">{{pkg.width||'?'}}cm</div>
						<div class="b5">{{pkg.height||'?'}}cm</div>
						<div class="b6">{{pkg.volume||'?'}}m³</div>
						<div class="b7">{{pkg.weight||'?'}}kg</div>
						<div class="b8">{{item.goodsTypeName||'?'}}</div>
					</div>
				</div>
			</div>
			<div class="rmsg">
				<div class="tit">运单详情</div>
				<div class="itm">
					<div class="lab">快递单号</div>
					<div class="val">{{pkg.expressNumber || '--'}}</div>
				</div>
				<div class="itm">
					<div class="lab">寄往地区</div>
					<div class="val">{{pkg.countryName || '--'}}</div>
				</div>
				<div class="itm">
					<div class="lab">所在仓库</div>
					<div class="val">{{pkg.warehouse.name || '--'}}</div>
				</div>
				<div class="itm">
					<div class="lab">客户备注</div>
					<div class="val">{{pkg.remark || '--'}}</div>
				</div>
				<div class="itm">
					<div class="lab">入库备注</div>
					<div class="val">{{pkg.adminRemark || '--'}}</div>
				</div>
				<div class="itm">
					<div class="lab">预报时间</div>
					<div class="val">{{pkg.createTime || '--'}}</div>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
import { packagedetail } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			pkg:'',
			status:0,
			packageList:[],
		}
	},
	mounted() {
		this.id = this.$route.query.id
		this.packagedetailGet()
	},
	methods:{
		// 获取包裹详情
		async packagedetailGet(){
			const res = await packagedetail({id:this.id})
			if(res.code==200){
				var data = res.data
				this.pkg = data
				var status = data.status
				if(status>=2&&status!=6){
					this.status = status*1-2
				}
				// 构建物品列表
				this.packageList = [{
					gallery: data.gallery || [],
					name: data.name || '',
					pieceNum: data.pieceNum || '',
					cost: data.cost || '',
					goodsTypeName: data.goodsTypeName.join(',') || '',
				}]
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 面包屑 ========== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover {
		color: #0096FF;
	}
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}
.packStatus{
	width: 100%;
	background: #fff;
	border-radius: 12px;
	padding-top: 40px;
	padding-bottom: 40px;
}
.status-t1{
	font-size: 16px;
	color: #333333;
	padding: 6px 0;
	display: inline-block;
}
.status-t2{
	font-size: 14px;
	color: #666666;
}
.status-t3{
	width: 10px;
	height: 10px;
	background: #DFE0E6;
	border-radius: 50%;
	display: inline-block;
}
.status-t3-a{
	background: #0096FF!important;
}
.msgBox{
	margin-top: 24px;
	align-items: flex-start;
	.table{
		width: 1236px;
		padding: 24px;
		padding-bottom: 38px;
		border-radius: 12px;
		background: #fff;
	}
	.rmsg{
		width: 340px;
		padding: 24px;
		padding-bottom: 12px;
		border-radius: 12px;
		background: #fff;
		.tit{
			font-size: 15px;
			color: #0096FF;
			padding-bottom: 12px;
		}
		.itm{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 12px;
			.lab{
				font-size: 14px;
				color: #666666;
			}
			.val{
				font-size: 14px;
				color: #666666;
			}
		}
	}
}
// 新版表格
.newTable{
	.title{
		width: 100%;
		height: 57px;
		border: 1px solid #F0F0F0;
		background: #FAFAFA;
		border-radius: 8px;
		color: #333333;
		font-size: 14px;
		.t1{
			padding-left: 31px;
			font-size: 14px;
			width: 376px;
		}
		.t2{
			text-align: center;
			width: 100px;
		}
		.t3{
			text-align: center;
			width: 100px;
		}
		.t4{
			text-align: center;
			width: 100px;
		}
		.t5{
			text-align: center;
			width: 100px;
		}
		.t6{
			text-align: center;
			width: 100px;
		}
		.t7{
			text-align: center;
			width: 100px;
		}
		.t8{
			text-align: center;
			width: 210px;
		}
	}
	.goodsItem{
		margin-top: 20px;
		border: 1px solid #F0F0F0;
		border-radius: 20px;
		width: 100%;
		.topBox{
			height: 70px;
			width: 100%;
			border: 1px solid #F0F0F0;
			padding: 0 24px;
			.sn{
				margin-right: 32px;
				p{
					font-size: 16px;
				}
				.el-image{
					width: 22px;
					height: 22px;
					display: block;
					margin-left: 12px;
				}
			}
			.time{
				font-size: 16px;
				margin-right: 32px;
			}
			.ftype{
				font-size: 16px;
			}
		}
		.gmsg{
			padding: 24px 0;
			.b1{
				width: 376px;
				padding-left: 24px;
				.b1itm{
					margin-bottom: 24px;
					&:last-child{
						margin-bottom: 0;
					}
				}
				.el-image{
					width: 108px;
					height: 108px;
					border-radius: 4px;
					display: block;
					margin-right: 16px;
				}
				.txtBox{
					width: calc(100% - 124px);
					.t1{
						font-size: 14px;
						color: #0096FF;
					}
					.t2{
						font-size: 16px;
						margin-top: 6px;
						line-height: 1.6;
					}
					.t3{
						color: #666666;
						margin-top: 6px;
					}
				}
			}
			.b2{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b3{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b4{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b5{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b6{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b7{
				text-align: center;
				font-size: 16px;
				width: 100px;
			}
			.b8{
				text-align: center;
				width: 210px;
				font-size: 16px;
				div{
					cursor: pointer;
				}
				.btn1{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #0096FF;
					font-size: 14px;
					color: #0096FF;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn2{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #FC3C3C;
					font-size: 14px;
					color: #FC3C3C;
					text-align: center;
					line-height: 32px;
					margin: auto;
					margin-bottom: 6px;
				}
				.btn3{
					width: 144px;
					height: 32px;
					border-radius: 4px;
					border: 1px solid #DDDFE5;
					font-size: 14px;
					color: #606266;
					text-align: center;
					line-height: 32px;
					margin: auto;
				}
			}
		}
	}
}
*{
	color: #333333;
}
</style>